//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'

export default {
  components: {
    DialogAddDealer: () => import('../DialogAddDealer/index.vue'),
    DialogEditDealer: () => import('../DialogEditDealer/index.vue'),
    DialogDetailDealer: () => import('../DialogDetailDealer/index.vue')
  },
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      rowData: {
        default: () => ({})
      },
      addDialogVisible: false,
      editDialogVisible: false,
      detailDialogVisible: false
    }
  },
  watch: {
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    handleDeleteRow: function (row) {
      let data = _.pick(row, 'dealerId')
      // console.log('data', data)
      this.$axios.post('/mtea/store/admin/dealer/del', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    }
  }
}
